import PropTypes from 'prop-types'

import { getDisplayName, getUrlParam } from 'utils/mixpanel'

export const withAnalytics = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { mixpanel, location, accountId, profileName } = props

    const trackers = {
      trackActionClick: ({ action }) =>
        mixpanel.track('Orders List_Actions DropUp Selection', {
          'Action Selected': action.text,
          ...getUrlParam(location),
        }),
      trackPaginationChange: ({ activePage }) => {
        mixpanel.track('Orders List_Pagination Clicked', {
          'Page number': `Page_${activePage}`,
          ...getUrlParam(location),
        })
      },
      trackPageSizeChange: ({ size }) => {
        mixpanel.track('Orders List_Page Size Clicked', {
          'Page size': size,
          ...getUrlParam(location),
        })
      },
      trackOpenImportOrdersModal: () => {
        mixpanel.track(
          'Orders List_Import Orders Button Clicked',
          getUrlParam(location),
        )
      },
      trackOpenStartOrderModal: () => {
        mixpanel.track(
          'Orders List_Start Order Button Clicked',
          getUrlParam(location),
        )
      },
      trackDownloadOrderModal: () => {
        mixpanel.track(
          'Orders List_Download Order Confirmation Button Clicked',
          getUrlParam(location),
        )
      },
      trackOpenExportDataModal: () => {
        mixpanel.track(
          'Orders List_Export Data Button Clicked',
          getUrlParam(location),
        )
      },
      trackClickCancelReplaceButton: () => {
        mixpanel.track(
          'Orders List_Cancel/Replace Style Button Clicked',
          getUrlParam(location),
        )
      },
      trackClickSendInvoices: (orderCount) =>
        mixpanel.track('Payments_Invoices Sent', {
          User: accountId,
          Brand: profileName,
          ...getUrlParam(location),
          InvoicesSent: orderCount,
        }),
      trackClickChangeStatus: (orderCount) =>
        mixpanel.track('Orders List_Actions DropUp Change Status', {
          User: accountId,
          Brand: profileName,
          ...getUrlParam(location),
          OrdersChanged: orderCount,
        }),
      trackClickCopyOrders: (orderCount) =>
        mixpanel.track('Orders List_Actions DropUp Copy Orders', {
          User: accountId,
          Brand: profileName,
          ...getUrlParam(location),
          OrdersCopied: orderCount,
        }),
      trackClickRemoveStyleColorWithoutQuantities: (orderCount) =>
        mixpanel.track(
          'Orders List_Actions DropUp Remove Style Color Without Quantities',
          {
            User: accountId,
            Brand: profileName,
            ...getUrlParam(location),
            SelectedOrders: orderCount,
          },
        ),
      trackOpenMoveProducts: () => {
        mixpanel.track('Orders List_Move Producs Button Clicked', {
          User: accountId,
          Brand: profileName,
          ...getUrlParam(location),
        })
      },
    }

    return <WrappedComponent {...props} {...trackers} />
  }

  Wrapper.propTypes = {
    mixpanel: PropTypes.object,
    location: PropTypes.object.isRequired,
  }
  Wrapper.defaultProps = {
    mixpanel: { track: () => {} },
  }

  Wrapper.displayName = `withAnalytics(${getDisplayName(WrappedComponent)})`
  return Wrapper
}

export default withAnalytics
